(() => {
  function enableGallery() {
    const gallery = document.querySelector('[data-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const thumbs = [...gallery.querySelectorAll('[data-poster-index]')];
    const strip = gallery.querySelector('.poster-thumbnails');
    const opener = gallery.querySelector('[data-poster-open]');
    const main = gallery.querySelector('[data-poster-image]');
    const dialog = gallery.querySelector('dialog');
    const art = gallery.querySelector('[data-viewer-art]');
    const error = gallery.querySelector('.poster-error');
    const cache = new Map();
    let selected = 0, requested = 0, revision = 0, suppressClick = false;
    function load(src) {
      if (!cache.has(src)) {
        const img = new Image(); img.src = src;
        cache.set(src, img.decode().then(() => img).catch(e => { cache.delete(src); throw e; }));
      }
      return cache.get(src);
    }
    function viewerImage() {
      const token = revision;
      const data = thumbs[selected].dataset;
      const img = new Image();
      img.src = main.currentSrc || main.src;
      img.alt = main.alt; img.width = main.width; img.height = main.height;
      art.replaceChildren(img);
      gallery.querySelector('[data-viewer-caption]').textContent = data.title;
      gallery.querySelector('[data-viewer-position]').textContent = `${selected + 1} / ${thumbs.length}`;
      // Keep the decoded pane image visible until the detailed image is ready.
      load(data.large).then(() => {
        if (revision === token && dialog.open) img.src = data.large;
      }).catch(() => {});
    }
    async function select(index) {
      requested = (index + thumbs.length) % thumbs.length;
      const target = requested, token = ++revision, data = thumbs[target].dataset;
      try { await load(data.main); } catch {
        if (token === revision) { error.textContent = 'The image could not load. Please try again.'; error.hidden = false; }
        return;
      }
      if (token !== revision) return;
      selected = target;
      main.removeAttribute('srcset'); main.removeAttribute('sizes');
      main.src = data.main; main.alt = data.alt;
      gallery.classList.toggle('artwork-gallery',data.imageKind==='artwork');
      main.width = Number(data.width); main.height = Number(data.height);
      const action = gallery.querySelector('[data-poster-action]');
      action.href = data.action; action.textContent = data.actionLabel;
      opener.href = data.large; opener.setAttribute('aria-label', `Enlarge ${data.title}`);
      gallery.querySelector('[data-poster-caption]').textContent = data.title;
      gallery.querySelector('[data-poster-position]').textContent = `${selected + 1} / ${thumbs.length}`;
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
      // Scroll only the thumbnail strip, never the surrounding page or modal.
      // An immediate adjustment also avoids a visible rewind on endpoint wraps.
      const bounds = strip.getBoundingClientRect(), thumbBounds = thumbs[selected].getBoundingClientRect();
      if (thumbBounds.left < bounds.left + 6 || thumbBounds.right > bounds.right - 6) {
        strip.scrollLeft += thumbBounds.left - bounds.left - (strip.clientWidth - thumbBounds.width) / 2;
      }
      error.hidden = true;
      if (dialog.open) viewerImage();
    }
    gallery.addEventListener('click', event => {
      const step = event.target.closest('[data-poster-step]');
      const thumb = event.target.closest('[data-poster-index]');
      if (step) void select(requested + Number(step.dataset.posterStep));
      if (thumb) void select(Number(thumb.dataset.posterIndex));
      if (event.target.closest('[data-poster-open]')) {
        event.preventDefault();
        if (suppressClick) { suppressClick = false; return; }
        dialog.showModal(); viewerImage();
        gallery.querySelector('[data-poster-close]').focus();
      }
      if (event.target.closest('[data-poster-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
    gallery.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (thumbs.length > 1 && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
        event.preventDefault(); void select(requested + (event.key === 'ArrowRight' ? 1 : -1));
      }
      if (dialog.open && event.key === 'Tab') {
        const buttons = [...dialog.querySelectorAll('button')].filter(button => button.getClientRects().length);
        const first = buttons[0], last = buttons.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    for (const surface of [opener, art]) {
      let start;
      surface.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.isPrimary && event.pointerType !== 'mouse') {
          start = {x:event.clientX,y:event.clientY,id:event.pointerId};
          surface.setPointerCapture(event.pointerId);
        }
      });
      surface.addEventListener('pointercancel', () => { start = null; });
      surface.addEventListener('pointerup', event => {
        if (!start || event.pointerId !== start.id) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y; start = null;
        if (thumbs.length > 1 && Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          suppressClick = true; void select(requested + (dx < 0 ? 1 : -1));
        }
      });
    }
    // Fetch only pane-sized images in the background, after the first poster is ready.
    load(thumbs[0].dataset.main).then(() => {
      const warm = async () => { for (const thumb of thumbs.slice(1)) { try { await load(thumb.dataset.main); } catch {} } };
      if ('requestIdleCallback' in window) requestIdleCallback(warm); else setTimeout(warm, 300);
    }).catch(() => {});
  }
  function updateVariant(section) {
    const select=section.querySelector('[data-variant-select]');
    const option=select.selectedOptions[0];
    section.dataset.squareVariantId=option.dataset.squareVariantId||'';
    section.querySelector('[data-variant-price]').textContent=option.dataset.price;
    const reminder=section.parentElement.querySelector('[data-square-selection]');
    if(reminder)reminder.textContent=`Viewed here: ${option.dataset.size} — ${option.dataset.price}. Reselect this size on Square.`;
  }
  function enableVariants() {
    document.querySelectorAll('[data-product-variants]').forEach(section=>{
      updateVariant(section);
      section.querySelector('[data-variant-controls]').hidden=false;
      section.querySelector('[data-variant-price-list]').open=false;
    });
  }
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-variant-select]'))updateVariant(event.target.closest('[data-product-variants]'));
  });
  function filterShirts() {
    const collection=document.querySelector('[data-shirt-collection]');
    if(!collection)return;
    const select=collection.querySelector('[data-style-filter]');
    const route=new URL(window.VO_PREVIEW?(location.hash.slice(1)||'/'):location.href,'https://preview.invalid');
    const character=collection.querySelector('[data-character-filter]');
    const requestedCharacter=route.searchParams.get('character')||'all';
    character.value=[...character.options].some(o=>o.value===requestedCharacter)?requestedCharacter:'all';
    const requested=route.searchParams.get('style')||'all';
    select.value=['all','saying','character','original'].includes(requested)?requested:'all';
    let count=0;
    collection.querySelectorAll('[data-product-id]').forEach(card=>{
      const show=(select.value==='all'||card.dataset.style===select.value)&&(character.value==='all'||card.dataset.character===character.value);
      card.hidden=!show;if(show)count++;
    });
    collection.querySelectorAll('[data-originals-section]').forEach(section=>{section.hidden=![...section.querySelectorAll('[data-product-id]')].some(card=>!card.hidden);});
      collection.querySelector('[data-shirt-count]').textContent=`${count} ${count===1?'design':'designs'}`;
    collection.querySelector('[data-shirt-empty]').hidden=count!==0;
    collection.querySelector('[data-style-controls]').hidden=false;
  }
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-style-filter], [data-character-filter]'))return;
    const params=new URLSearchParams();
    for(const [key,selector] of [['style','[data-style-filter]'],['character','[data-character-filter]']]){const value=document.querySelector(selector).value;if(value!=='all')params.set(key,value);}
    const route='/pages/t-shirts'+(params.size?'?'+params:'');
    history.pushState(null,'',window.VO_PREVIEW?'#'+route:route);filterShirts();
  });
  window.addEventListener('popstate',()=>{if(!window.VO_PREVIEW)filterShirts();});
  function renderPreview() {
    if (!window.VO_PREVIEW) return;
    const route = new URL(location.hash.slice(1) || '/', 'https://preview.invalid').pathname;
    const redirected = window.VO_REDIRECTS[route] || window.VO_REDIRECTS[route.replace(/index\.html$/, '')] || window.VO_REDIRECTS[route + '/'];
    if (redirected) { location.replace('#' + redirected); return; }
    const page = window.VO_PAGES[route] || window.VO_PAGES['/404.html'];
    document.querySelector('#app').innerHTML = page.body;
    document.title = page.title;
    window.scrollTo(0, 0);
    enableGallery(); filterShirts(); enableVariants();
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || !window.VO_PREVIEW || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    const href = link.getAttribute('href');
    if (href === '#main') {
      event.preventDefault();
      const main = document.querySelector('#main');main.focus();main.scrollIntoView();
    } else if (href.startsWith('/')) { event.preventDefault(); location.hash = href; }
  });
  window.addEventListener('hashchange', renderPreview);
  if (window.VO_PREVIEW) renderPreview(); else { enableGallery(); filterShirts(); enableVariants(); }
})();
